import {
  Checkbox,
  FormControlLabel,
  FormControlLabelProps,
} from "@mui/material";
import { neutral } from "@flat-ui";

interface Props {
  /** True if the checkbox should be marked as checked */
  isChecked: boolean;

  /** Callback when the checkbox will be clicked */
  onChange(): void;

  /** Text that displayed with the checkbox */
  label?: string;

  /** If true, the checkbox is disabled. */
  isDisabled?: boolean;

  /** Optional sx properties to override the checkbox style. */
  sx?: FormControlLabelProps["sx"];
}

/** Renders checkbox with label */
export function FaroCheckbox({
  isChecked,
  label,
  onChange,
  isDisabled,
  sx = {},
}: Props): JSX.Element {
  return (
    <FormControlLabel
      control={
        <Checkbox
          size="small"
          disableRipple
          disableFocusRipple
          disableTouchRipple
          checked={isChecked}
          onChange={onChange}
          disabled={isDisabled}
        />
      }
      sx={{
        "& .MuiFormControlLabel-label": {
          color: neutral[800],
        },
        ...sx,
      }}
      label={label}
    />
  );
}
